module.exports = __webpack_public_path__ + "img/ca.87b06694.svg";